import { CategoryBadge } from "./CategoryBadge";

// The revealed front of the card: shows the question.
export const CardFront = ({ question }) => {
  const displayCategory = question?.seedKey?.startsWith("fun-") ? "FUN" : question.category;

  return (
    <div
      className="card-face card-front"
      style={{
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
        transform: "rotateY(180deg) translateZ(0.1px)",
        WebkitTransform: "rotateY(180deg) translateZ(0.1px)",
      }}
    >
      <div className="card-front-top">
        <CategoryBadge category={displayCategory} />
      </div>

      <div className="card-front-content">
        <div className="card-front-symbol" aria-hidden="true">✦</div>
        <p className="card-front-text" data-testid="card-question-text">
          {question.text}
        </p>
      </div>

      <div className="card-front-bottom">
        <span className="intensity-dots">
          {[1, 2, 3, 4].map((i) => (
            <span key={i} className={`dot ${i <= question.intensity ? "dot-on" : ""}`} />
          ))}
        </span>
      </div>
    </div>
  );
};

export default CardFront;
